var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModuleGames(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-module-games",
    transform: "translate(-31.498 0.502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5839",
    "data-name": "Rectangle 5839",
    width: 92,
    height: 92,
    transform: "translate(31.498 -0.502)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8844",
    "data-name": "Group 8844",
    transform: "translate(41.722 19.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41066",
    "data-name": "Path 41066",
    d: "M124.207,191.116H107.5c1.023-3.38,1.047-5.691.1-7.377-1.249-2.23-3.93-2.8-6.768-3.4a33.989,33.989,0,0,1-4.314-1.12c-5.7-2.009-4.172-7.334-3.977-7.942a1.142,1.142,0,0,0-2.169-.714c-.026.08-2.548,8.015,5.387,10.81a36.378,36.378,0,0,0,4.6,1.2c2.518.535,4.507.957,5.25,2.284.657,1.173.49,3.227-.506,6.262H87.3a15.73,15.73,0,1,0,13.08,24.47h10.743a15.731,15.731,0,1,0,13.081-24.47Zm0,29.177a13.366,13.366,0,0,1-11.481-6.444,1.141,1.141,0,0,0-.974-.546H99.758a1.141,1.141,0,0,0-.974.546A13.448,13.448,0,1,1,87.3,193.4h36.9a13.447,13.447,0,0,1,0,26.894Z",
    transform: "translate(-71.572 -169.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41067",
    "data-name": "Path 41067",
    d: "M104.306,236.2h-2.628V233.57a.913.913,0,0,0-.913-.913H95.218a.913.913,0,0,0-.913.913V236.2H91.675a.914.914,0,0,0-.913.913v5.547a.913.913,0,0,0,.913.913H94.3V246.2a.913.913,0,0,0,.913.913h5.546a.913.913,0,0,0,.913-.913v-2.629h2.628a.914.914,0,0,0,.913-.913v-5.547A.914.914,0,0,0,104.306,236.2Zm-.913,5.547h-2.629a.913.913,0,0,0-.913.913v2.629H96.131v-2.629a.913.913,0,0,0-.913-.913H92.589v-3.72h2.629a.913.913,0,0,0,.913-.913v-2.629H99.85v2.629a.913.913,0,0,0,.913.913h2.629Z",
    transform: "translate(-81.999 -203.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41068",
    "data-name": "Path 41068",
    d: "M183.643,239.321a3.366,3.366,0,1,0-3.366-3.366A3.37,3.37,0,0,0,183.643,239.321Zm0-4.906a1.54,1.54,0,1,1-1.54,1.54A1.541,1.541,0,0,1,183.643,234.415Z",
    transform: "translate(-130.635 -203.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41069",
    "data-name": "Path 41069",
    d: "M183.643,254.57a3.366,3.366,0,1,0,3.366,3.366A3.37,3.37,0,0,0,183.643,254.57Zm0,4.906a1.539,1.539,0,1,1,1.539-1.54A1.541,1.541,0,0,1,183.643,259.476Z",
    transform: "translate(-130.635 -215.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41070",
    "data-name": "Path 41070",
    d: "M194.634,243.579A3.366,3.366,0,1,0,198,246.945,3.37,3.37,0,0,0,194.634,243.579Zm0,4.906a1.539,1.539,0,1,1,1.54-1.539A1.541,1.541,0,0,1,194.634,248.485Z",
    transform: "translate(-136.608 -209.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41071",
    "data-name": "Path 41071",
    d: "M176.018,246.945a3.366,3.366,0,1,0-3.366,3.366A3.37,3.37,0,0,0,176.018,246.945Zm-3.366,1.539a1.539,1.539,0,1,1,1.539-1.539A1.541,1.541,0,0,1,172.652,248.485Z",
    transform: "translate(-124.664 -209.877)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleGames);
export default __webpack_public_path__ + "static/media/icon-module-games.b59a5fae.svg";
export { ForwardRef as ReactComponent };